import parseApolloError from '../../../util/apolloError';
import { useClipCommentsQuery } from '../operation.generated';

interface useClipCommentsProps {
  clipId?: string;
}

const useClipComments = ({ clipId }: useClipCommentsProps) => {
  const {
    data: commentsData,
    loading,
    error,
    refetch,
  } = useClipCommentsQuery({
    variables: {
      inputs: {
        clipId: clipId || '',
      },
    },
    skip: !clipId,
  });

  return {
    comments: commentsData?.comments.edges.map(edge => edge.node) || [],
    loading,
    error: error ? parseApolloError(error) : undefined,
    refetch,
  };
};

export default useClipComments;
